module.exports = __webpack_public_path__ + "img/niger.ae3ede8b.svg";